module.exports = __webpack_public_path__ + "img/erweima5.288d8026.png";